// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"298":"e61795d5","343":"c8bbafa9","453":"ed3810f9","544":"e3af6faf"}[chunkId] + ".chunk.js";
};